







































import { Component, Watch, Vue } from "vue-property-decorator";

import PageTitle from "@/components/common/PageTitle.vue";
import OrderBlock from "@/components/pages/Account/Orders/blocks/Order.vue";

import { GRD } from "@/services/consts";
import { ordersModule, personalModule } from "@/plugins/store-accessors";

@Component({
  components: {
    PageTitle,
    OrderBlock,
  },
})
export default class OrdersPage extends Vue {
  opened: number[] = [];

  get meta() {
    return ordersModule.getMeta;
  }

  get orders() {
    return ordersModule.getOrders;
  }

  get headers() {
    return ordersModule.getHeaders;
  }

  get links() {
    return ordersModule.getLinks;
  }

  get isAuthorized() {
    return personalModule.isAuthorized;
  }

  @Watch("isAuthorized")
  async authGuard(state: boolean) {
    state ? await this.sendRequest() : this.openModal();
  }

  openModal() {
    personalModule.showLoginModal(GRD.order);
  }

  expandHandler(i: number) {
    const copy = [...this.opened];
    const match = copy.findIndex(index => i === index);
    if (match > -1) {
      copy.splice(match, 1);
    } else {
      copy.push(i);
    }
    this.opened = copy;
  }

  async sendRequest() {
    return await ordersModule.requestOrders();
  }

  setMeta() {
    document.title = this.meta.title as string;
  }

  async indexRequest() {
    await this.authGuard(this.isAuthorized);
    this.setMeta();
  }

  mounted() {
    this.indexRequest();
  }
}
